import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  getCategories,
  searchSign,
} from "../../../services/database/database_service";
import { setCategories } from "../../../store/categorySlice";

import ln from "../../../assets/lines/line1.png";
import LoadingIndicator from "../components/LoadingIndicator";
import { useLanguage } from "../../../services/localization/LanguageContex";


function SignsScreen() {
  const {t,language} = useLanguage();

  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // NEW
  const categories = useSelector((state) => state.category.categories);

  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  // Debounced search effect
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const doSearch = async () => {
        if (searchTerm.trim() === "") {
          setSearchResults([]);
          return;
        }
        setIsSearching(true);
        try {
          const res = await searchSign(searchTerm);
          setSearchResults(res.documents);
          
        } catch (e) {
          setSearchResults([]);
        } finally {
          setIsSearching(false);
        }
      };
      doSearch();
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

 
  useEffect(() => {
    window.scrollTo(0, 0);
    // window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        dispatch(setCategories(data.documents));
      } catch (err) {
        setError(err.message); // Show a user-friendly message
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [dispatch]);

  return (
    <Box 
    // sx={{ p: 6, pt: 2 }}
    sx={{ px: { xs: 3, sm: 6, md: 6 }, pt: 2 ,pb:6}}
    
    >
      <Typography variant="h4" gutterBottom align="center" sx={{ mb: 2 }}>
         {t("Explore our Signs")}
      </Typography>

      {/* 🔍 Search Bar */}
      <Box sx={{ maxWidth: 400, mx: "auto", mb: 4, position: "relative" }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder={t("Search signs ...")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {/* 🔍 Search results dropdown */}
        {searchTerm && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              bgcolor: "background.paper",
              boxShadow: 3,
              zIndex: 10,
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 1,
              mt: 1,
            }}
          >
            {isSearching ? (
              <Typography sx={{ p: 2 }} align="center">
                {t("Searching...")}...
              </Typography>
            ) : searchResults.length === 0 ? (
              <Typography sx={{ p: 2 }} align="center">
                {t("No results found")}
              </Typography>
            ) : (
              searchResults.map((result) => (
                <Link
                  key={result.id}
                  to={`./result?search_query=${encodeURIComponent(
                    result.enTitle
                  )}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Box
                    sx={{
                      p: 2,
                      "&:hover": { bgcolor: "grey.100", cursor: "pointer" },
                    }}
                  >
                    <Typography variant="subtitle2">
                      {result.enTitle}
                      {/* {language == "en" ? result.enTitle} */}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {result.dzTitle}
                    </Typography>
                  </Box>
                </Link>
              ))
            )}
          </Box>
        )}
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <LoadingIndicator />
        </Box>
      ) : error ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      ) : categories.length === 0 ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="h6" color="textSecondary">
            No categories found.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={4}>
          {categories.map((cat) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={cat.$id}>
              <Link
                to={`./${encodeURIComponent(cat.category)}`}
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 180,
                    boxShadow: 5,
                    "&:hover": {
                      cursor: "pointer",
                      boxShadow: 7,
                      transform: "translateY(-2px)",
                    },
                    pl: 5,
                    pr: 5,
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle1" align="center">
                      {/* {language === "en" 
                        ? cat.category.charAt(0).toUpperCase() + cat.category.slice(1)
                        : (t(cat.category) !== cat.category 
                            ? t(cat.category) 
                            : cat.category.charAt(0).toUpperCase() + cat.category.slice(1)
                          )
                      } */}

                        {language === "en" 
                        ? cat.category
                        : (t(cat.category) !== cat.category 
                            ? t(cat.category) 
                            : cat.category
                          )
                      }

                    </Typography>
                    <Box
                      component="img"
                      src={ln}
                      alt="line"
                      loading="lazy"
                      sx={{
                        ml: 2,
                        mr: 2,
                        width: "100%",
                        height: "auto",
                        maxWidth: "100%",
                        maxHeight: { xs: 50, sm: 100, md: 150 },
                      }}
                    />
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}

export default SignsScreen;
